import { Config } from './../classes/config';
import { Kondition } from './../classes/login';
import { Component, OnInit } from '@angular/core';
import { PopoverController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-kondition-popover',
  templateUrl: './kondition-popover.page.html',
  styleUrls: ['./kondition-popover.page.scss'],
})
export class KonditionPopoverPage implements OnInit {
  public kondition: Kondition;
  public konditionen: Kondition[];
  public config: Config;

  constructor(public popoverCtrl: PopoverController, navParams: NavParams) {
    this.kondition = navParams.get('kondition');
    this.kondition = navParams.get('konditionen');
    this.config = navParams.get('config');
  }

  ngOnInit() {
  }

  select(value) {
    this.popoverCtrl.dismiss({kondition: value});
  }
}
